import React from "react";
import { Bar } from "react-chartjs-2";
import EnsaConstant from "../../../pages/Reports/ensa/EnsaConstant";

const ChartBar = (dataLiterasi) => {
    function getDataChart(param) {
        let listData = []
        for (let i in dataLiterasi.dataLiterasi) {
            const item = dataLiterasi.dataLiterasi[i]
            if (item.key === param) {
                listData = item.value
            }
        }
        return listData.map((item) => {return item.value});
    }
    
    const options = {
        type: "bar",
        responsive: true,
        aspectRatio: 1,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                display: false,
                stacked: true,
            },
            yAxes: [
                {
                    scaleLabel: {
                        display: false,
                        labelString: "probability",
                    },
                },
            ],
        },
    };

    const data = {
        labels: EnsaConstant.LABEL.CHART_BAR_HASIL_SK,
        datasets: [
            {
                label: "Belum Terinternalisasi",
                yAxisID: "bar-stack",
                backgroundColor: "#FF3838",
                borderColor: "#FF3838",
                borderWidth: 1,
                stack: "now",
                data: getDataChart('BELUM TERINTERNALISASI')
            },
            {
                label: "Perlu Dikembangkan",
                yAxisID: "bar-stack",
                backgroundColor: "#FEBC04",
                borderColor: "#FEBC04",
                borderWidth: 1,
                stack: "now",
                data: getDataChart('PERLU DIKEMBANGKAN')
            },
            {
                label: "Berkembang",
                yAxisID: "bar-stack",
                backgroundColor: "#03C46B",
                borderColor: "#03C46B",
                borderWidth: 1,
                stack: "now",
                data: getDataChart('BERKEMBANG')
            },
            {
                label: "Membudaya",
                yAxisID: "bar-stack",
                backgroundColor: "#015E56",
                borderColor: "#015E56",
                borderWidth: 1,
                stack: "now",
                data: getDataChart('MEMBUDAYA')
            },
        ],
    };

    return <Bar data={data} options={options} />;
};

export default ChartBar;
